import { render, staticRenderFns } from "./IssueActions.vue?vue&type=template&id=6582e7aa"
import script from "./IssueActions.vue?vue&type=script&lang=ts"
export * from "./IssueActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,AutofixFileChooser: require('/build/apps/legacy/components/RepoIssues/Modals/AutofixFileChooser.vue').default,UpgradeAccountModal: require('/build/apps/legacy/components/Billing/Modals/UpgradeAccountModal.vue').default,ZMenuItem: require('/build/apps/legacy/components/zeal/ZMenu/ZMenuItem/ZMenuItem.vue').default,ZMenu: require('/build/apps/legacy/components/zeal/ZMenu/ZMenu.vue').default,IgnoreIssueAllFiles: require('/build/apps/legacy/components/RepoIssues/Modals/IgnoreIssueAllFiles.vue').default,IgnoreIssueTestFiles: require('/build/apps/legacy/components/RepoIssues/Modals/IgnoreIssueTestFiles.vue').default,IgnoreIssueFilePattern: require('/build/apps/legacy/components/RepoIssues/Modals/IgnoreIssueFilePattern.vue').default,ZSplitButtonDropdown: require('/build/apps/legacy/components/zeal/ZSplitButtonDropdown/ZSplitButtonDropdown.vue').default})
